function isElement(el: HTMLElement | null): el is HTMLElement {
    return el !== null;
}

export default null;
export {
    isElement
};